// extracted by mini-css-extract-plugin
export var bg = "blog-module--bg--zWO2w";
export var bgdesktop = "blog-module--bgdesktop--N62zR";
export var bgmobile = "blog-module--bgmobile--BkWPM";
export var bgtablet = "blog-module--bgtablet--OK1RV";
export var bgxl = "blog-module--bgxl--gvEjr";
export var blogtitle = "blog-module--blogtitle--4DIBx";
export var blurb = "blog-module--blurb--FWQsq";
export var bottom = "blog-module--bottom--7WXRp";
export var callout = "blog-module--callout--SsLp-";
export var contentleft = "blog-module--contentleft--BcPCW";
export var date = "blog-module--date--+WPQf";
export var excerpt = "blog-module--excerpt--Bytvq";
export var heading = "blog-module--heading--RMkP2";
export var hovericon = "blog-module--hovericon--er9hE";
export var icon = "blog-module--icon--xwyK1";
export var left = "blog-module--left--miB2h";
export var leftblurb = "blog-module--leftblurb--7e17w";
export var leftbottom = "blog-module--leftbottom--D1r5K";
export var lefttop = "blog-module--lefttop--VtNox";
export var link = "blog-module--link--wq1AR";
export var linkhover = "blog-module--linkhover--tBuFq";
export var logo = "blog-module--logo--nA0Ms";
export var logolink = "blog-module--logolink--Os--O";
export var post = "blog-module--post--u29Uf";
export var postcontainer = "blog-module--postcontainer--oSjz5";
export var readmore = "blog-module--readmore--cWizh";
export var request = "blog-module--request--xhAJI";
export var right = "blog-module--right--BJ5Og";
export var servicecontent = "blog-module--servicecontent--OWVke";
export var servicename = "blog-module--servicename--jWHle";
export var title = "blog-module--title--TdY0b";
export var top = "blog-module--top--MN0JD";